import GradientEditor from "./GradientEditor"

export default GradientEditor
